import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadSubscriptions = createAsyncThunk(
  "subscriptions/loadSubscriptions",
  async ({userId, mustValidateToken}, thunkAPI) => {
    try {
      const response = await API(`secure/subscriptions/${userId}`, {method: "GET", mustValidateToken});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkSubscriptions = createAsyncThunk("subscriptions/checkSubscriptions", async (userId, thunkAPI) => {
  try {
    const response = await API(`secure/subscriptions/${userId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadClientSecret = createAsyncThunk("subscriptions/loadClientSecret", async (_, thunkAPI) => {
  try {
    const response = await API("secure/v2/subscriptions/load-client");

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const cancelSubscription = createAsyncThunk("subscriptions/cancelSubscription", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/subscriptions/cancel", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateReactivateSubscription = createAsyncThunk(
  "subscriptions/updateReactivateSubscription",
  async (payload, thunkAPI) => {
    try {
      const response = await API("secure/v2/subscriptions/reactivate", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateCardDetails = createAsyncThunk("subscriptions/updateCardDetails", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/subscriptions/change-card", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateNextDispatch = createAsyncThunk("subscriptions/updateNextDispatch", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/subscriptions/update-dispatch", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateCollectionMethod = createAsyncThunk(
  "subscriptions/updateCollectionMethod",
  async (payload, thunkAPI) => {
    try {
      const response = await API("secure/v2/subscriptions/update-collection-method", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateBaseTest = createAsyncThunk("subscriptions/updateBaseTest", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/subscriptions/update-base-test", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const checkPlusTestAvailable = createAsyncThunk(
  "subscriptions/checkPlusTestAvailable",
  async (payload, thunkAPI) => {
    try {
      const response = await API("bespoke-test/check-available-tests", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const createBespokeTest = createAsyncThunk("subscriptions/createBespokeTest", async (payload, thunkAPI) => {
  try {
    const response = await API("bespoke-test/add-test", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getPlusTestByTestId = createAsyncThunk("subscriptions/getPlusTestByTestId", async ({testId}, thunkAPI) => {
  try {
    const response = await API(`bespoke-test/get-edit-test/${testId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
